import { render, staticRenderFns } from "./tab-pane.vue?vue&type=template&id=3d87661c"
import script from "./tab-pane.vue?vue&type=script&lang=js"
export * from "./tab-pane.vue?vue&type=script&lang=js"
import style0 from "./tab-pane.vue?vue&type=style&index=0&id=3d87661c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports